
(function () {
  'use strict';

  var pending = null;
  var launching = false;
  var ALLOW = 'data-agego-allow';

  function reset() {
    launching = false;
    pending = null;
  }

  function proceed() {
    var button = pending;
    reset();

    if (!button) return;

    // Continue using Ella's original checkout destination
    var destination = button.getAttribute('data-href');

    if (destination) {
      window.location.assign(destination);
    } else {
      window.location.assign('/checkout');
    }
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest('#cart-checkout');

    if (!button) return;

    if (button.getAttribute(ALLOW) === '1') return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (launching) return;

    launching = true;
    pending = button;

    if (typeof window.AGEGO !== 'function') {
      console.error('[AgeGO] Script is not loaded.');
      reset();
      return;
    }

    window.AGEGO('launch');

  }, true);

  window.AgeGoGate = {

    onVerified: function () {
      proceed();
    },

    onAlreadyVerified: function () {
      if (launching) proceed();
    },

    onAbandoned: function () {
      reset();
    },

    onFailed: function () {
      reset();
    },

    onExpired: function () {
      reset();
    }

  };

})();
